import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './ReportsLayout.scss';
import ReportPicker from 'src/components/Views/Reports/ReportPicker';
import PowerBiReport from 'src/components/Views/Reports/PowerBi/PowerBiReport';
import { Modal, Backdrop, Fade, Box, Typography, SvgIcon } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Grid from '@mui/material/Unstable_Grid2';
import { useReportsContext } from 'src/components/Views/Reports/ReportsContext';
import SigmaReport from 'src/components/Views/Reports/Sigma/SigmaReport';

export default function ReportsLayout({
    openedFromNav,
    handleCloseDialog,
}: {
    openedFromNav?: boolean;
    handleCloseDialog?: () => void;
}) {
    const { reports } = useReportsContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentReport, setCurrentReport] = useState<string | null>(null);
    const selectedReport = reports?.find((report) => report.reportName === currentReport);
    const isSigmaReport = Boolean(selectedReport?.sigmaReportName);

    const reportExpired = searchParams.get('reportExpired');

    const [openModal, setOpenModal] = useState(!!reportExpired);

    const handleClose = () => {
        setOpenModal(false);
    };

    useEffect(() => {
        const currentReport = searchParams.get('report');
        setCurrentReport(currentReport);
    }, [searchParams]);

    useEffect(() => {
        if (reportExpired) {
            setOpenModal(!!reportExpired);
            setSearchParams(undefined);
        }
    }, [reportExpired]);

    return (
        <>
            {!currentReport || openedFromNav ? (
                <ReportPicker handleCloseDialog={handleCloseDialog} reportsList={reports ?? []} />
            ) : null}

            {!!currentReport &&
                !openedFromNav &&
                (isSigmaReport ? (
                    <SigmaReport currentReport={currentReport} />
                ) : (
                    <PowerBiReport currentReport={currentReport} />
                ))}
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={openModal}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={openModal}>
                    <Box id="reports-modal">
                        <Grid container spacing={2}>
                            <Grid xs={12} textAlign="center">
                                <SvgIcon component={AccessTimeIcon} />
                            </Grid>
                            <Grid xs={12} textAlign="center">
                                <Typography variant="h5">Your session has has expired.</Typography>
                            </Grid>
                            <Grid xs={12} textAlign="center">
                                <Typography variant="h6">Please select a report to continue.</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Fade>
            </Modal>
        </>
    );
}
